export default __webpack_public_path__ + "static/media/User.5331882a.svg";